import {EstabProfissionalModel, IEstabProfissional} from './estab-profissional.model';
import {EstabEquipeModel, IEstabEquipe, IProfissionalEquipe} from './estab-equipe.model';
import {Guid} from 'guid-typescript';
import {IEstabEnderecoComplementar} from '../identificacao/estab-endereco-complementar.model';
import {FiltroBuscaGridModel, ResultadoBuscaGridModel} from '../classes-filtro-busca-grid';


export class RecursoHumanoModulo {
    profissionais: EstabProfissionalModel[];
    equipes: EstabEquipeModel[];

    constructor() {
        this.profissionais = [];
        this.equipes = [];
    }

    rascunhoParaRecursoHumano(rascunho: any) {
        this.rascunhoParaProfissional(rascunho);
        this.rascunhoParaEquipe(rascunho);
    }

    async buscarProfissionais(filtros: FiltroBuscaGridModel): Promise<ResultadoBuscaGridModel> {
        let listaOriginal: EstabProfissionalModel[] = [];
        if (this.profissionais && this.profissionais.length) {
            if (filtros.textoBuscaTextual.length > 1) {
                listaOriginal = await this.profissionais.filter(p =>
                    p.nome.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.cpf.includes(filtros.textoBuscaTextual) ||
                    p.cns.includes(filtros.textoBuscaTextual) ||
                    p.cbo.includes(filtros.textoBuscaTextual)
                );
            } else {
                listaOriginal = this.profissionais;
            }
        }
        return new ResultadoBuscaGridModel(filtros, listaOriginal);
    }

    async buscarEquipes(filtros: FiltroBuscaGridModel): Promise<ResultadoBuscaGridModel> {
        let listaOriginal: EstabEquipeModel[] = [];
        if (this.equipes && this.equipes.length) {
            if (filtros.textoBuscaTextual.length > 1) {
                listaOriginal = await this.equipes.filter(p =>
                    p.nomeReferencia.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.ine.includes(filtros.textoBuscaTextual) ||
                    p.subTipoEquipe.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.tipoEquipe.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase())
                );
            } else {
                listaOriginal = this.equipes;
            }
        }
        return new ResultadoBuscaGridModel(filtros, listaOriginal);
    }


    async salvarProfissional(profissional: EstabProfissionalModel, form: any) {
        profissional.cpf = form.cpf ? form.cpf : '';
        profissional.cns = form.cns ? form.cns : '';
        profissional.nome = form.nome ? form.nome : '';
        profissional.responsavelAdministrativo = form.responsavelAdministrativo ? form.responsavelAdministrativo : false;
        profissional.responsavelTecnico = form.responsavelTecnico ? form.responsavelTecnico : false;
        const indice = this.profissionais.findIndex(objFind => objFind.id === profissional.id);
        if (indice >= 0) {
            this.profissionais[indice] = profissional;
        } else {
            this.profissionais.push(profissional);
        }
    }

    async editarProfissional(profissional: EstabProfissionalModel) {
        const indice = this.profissionais.findIndex(objFind => objFind.id === profissional.id);
        this.profissionais[indice] = profissional;
    }

    async excluirProfissional(profissional: EstabProfissionalModel) {
        const indice = this.profissionais.findIndex(objFind => objFind.id === profissional.id);
        this.profissionais.splice(indice, 1);
    }

    async salvarEquipe(equipe: EstabEquipeModel, form: any) {
        equipe.ine = form.ine ? form.ine : '';
        equipe.idTipoEquipe = form.idTipoEquipe ? form.idTipoEquipe : '';
        equipe.tipoEquipe = form.tipoEquipe ? form.tipoEquipe : '';
        equipe.idSubTipoEquipe = form.idSubTipoEquipe ? form.idSubTipoEquipe : '';
        equipe.subTipoEquipe = form.subTipoEquipe ? form.subTipoEquipe : '';
        equipe.nomeReferencia = form.nomeReferencia ? form.nomeReferencia : '';
        equipe.idArea = form.idArea ? form.idArea : '';
        equipe.area = form.area ? form.area : '';
        equipe.dataAtivacao = form.dataAtivacao ? form.dataAtivacao : '';
        equipe.dataDesativacao = form.dataDesativacao ? form.dataDesativacao : '';
        equipe.idMotivoDesativacao = form.idMotivoDesativacao ? form.idMotivoDesativacao : '';
        equipe.motivoDesativacao = form.motivoDesativacao ? form.motivoDesativacao : '';
        equipe.saidaEquipe = form.saidaEquipe ? form.saidaEquipe : '';
        const indice = this.equipes.findIndex(objFind => objFind.id === equipe.id);
        if (indice >= 0) {
            this.equipes[indice] = equipe;
        } else {
            this.equipes.push(equipe);
        }
    }

    async excluirEquipe(equipe: EstabEquipeModel) {
        const indice = this.equipes.findIndex(objFind => objFind.id === equipe.id);
        this.equipes.splice(indice, 1);
    }


    private rascunhoParaProfissional(rascunho: any) {
        if (rascunho.profissionais && rascunho.profissionais.length > 0) {
            rascunho.profissionais.forEach((item) => {
                const profissional: IEstabProfissional = {
                    // tslint:disable-next-line:max-line-length
                    id: item.profissional ? item.profissional.id ? item.profissional.id : Guid.create().toString() : Guid.create().toString(),
                    cpf: item.profissional ? item.profissional.cpf : '',
                    cns: item.profissional ? item.profissional.cns : '',
                    nome: item.profissional ? item.profissional.nome : '',
                    responsavelAdministrativo: item.responsavelAdministrativo,
                    responsavelTecnico: item.responsavelTecnico,
                    residente: item.residente,
                    registrosOcupacoes: []
                };
                this.profissionais.push(new EstabProfissionalModel(profissional));
            });
        }
    }

    private rascunhoParaEquipe(rascunho: any) {
        if (rascunho.equipes && rascunho.equipes.length > 0) {
            rascunho.equipes.forEach((item) => {
                // tslint:disable-next-line:max-line-length
                const equipe: { area: any; dataAtivacao: any; ine: any; subTipoEquipe: any; idArea: any; motivoDesativacao: null; idTipoEquipe: any; idSubTipoEquipe: any; saidaEquipe: null; idMotivoDesativacao: null; profissionaisVinculados: IProfissionalEquipe[]; nomeReferencia: any; tipoEquipe: any; dataDesativacao: any; id: string } = {
                    id: Guid.create().toString(),
                    ine: item.INE,
                    idTipoEquipe: item.tipoEquipe, // TODO Código Tipo (Equipe)
                    tipoEquipe: item.descricaoTipoEquipe,
                    idSubTipoEquipe: item.codigoSubTipoEquipe, // TODO Código Sub Tipo (Equipe)
                    subTipoEquipe: item.subTipoEquipe, // TODO Descrição Sub Tipo (Equipe)
                    nomeReferencia: item.nomeReferencia, // TODO Nome Referencia (Equipe)
                    idArea: item.codigoArea, // TODO Código Área Equipe (Equipe) - Não sei se é necessário
                    area: item.area, // TODO Descrição Área Equipe (Equipe) - Não sei se é necessário
                    dataAtivacao: item.dataAtivacao,
                    dataDesativacao: item.dataDesativacao,
                    idMotivoDesativacao: null, // TODO Código Motivo Desativação (Equipe)
                    motivoDesativacao: null, // TODO Descição Motivo Desativação (Equipe)
                    saidaEquipe: null, // TODO Data Saída (Equipe)
                    // tslint:disable-next-line:max-line-length
                    profissionaisVinculados: item.profissionais ? this.rascunhoParaProfissionaisEquipe(item.profissionais) : [],
                    // tslint:disable-next-line:max-line-length
                    // enderecosComplementaresVinculados: item.unidadesApoio ? this.rascunhoParaEnderecoComplementarEquipe(item.unidadesApoio) : [],
                };
                this.equipes.push();
            });
        }
    }

    private rascunhoParaEnderecoComplementarEquipe(enderecosComplementares = []) {
        const listaEnderecos: IEstabEnderecoComplementar[] = [];
        /*enderecosVinculados.forEach((item) => {
            const endereco: IEstabEnderecoComplementar = {
                id: item.codigo ? item.codigo : Guid.create().toString(),
                identificacao: item.identificacao,
                cep: item.cep,
                logradouro: item.nomeLogradouro,
                // numero: item.numero,
                complemento: item.nomeComplemento,
                bairro: item.bairro,
                siglaUf: item.siglaUf,
                telefone: item.telefone,
                // municipio: item.municipio,
                // codigoIbgeMunicipio: item.codigoIbgeMunicipio,
                dataAtivacao: item.dataAtivacao,
                dataDesativacao: item.dataDesativacao
            };
            listaEnderecos.push(endereco);
        });*/
        return listaEnderecos;
    }

    private rascunhoParaProfissionaisEquipe(profissionais: any[]): IProfissionalEquipe[] {
        const listaProfissionaisEquipe: IProfissionalEquipe[] = [];
        profissionais.forEach((item) => {
            const profissional: IEstabProfissional = {
                id: Guid.create().toString(),
                cpf: item.profissional ? item.profissional.profissional.cpf : '',
                cns: item.profissional ? item.profissional.profissional.cpf : '',
                nome: item.profissional ? item.profissional.profissional.nome : '',
                responsavelAdministrativo: null,
                responsavelTecnico: null,
                residente: null,
            };
            const profissionalEquipe: IProfissionalEquipe = {
                registroOcupacao: undefined,
                id: item.profissional ? item.profissional.id ? item.profissional.id : Guid.create().toString() : Guid.create().toString(),
                dataDesligamento: item.dataDesligamento,
                dataEntrada: item.dataEntrada,
                equipeIne: item.equipeIne,
                quantidadeHoras: item.quantidadeHoras ? Number(item.quantidadeHoras) : 0,
                profissional
            };
            if (item.profissional.cbo) {
                // console.log('Entrou vinculo profissional equipe');
                profissionalEquipe.idCbo = item.profissional.cbo.id ? item.profissional.cbo.id : '';
                profissionalEquipe.cbo = item.profissional.cbo.descricao ? item.profissional.cbo.descricao : '';
                profissionalEquipe.idOrgaoEmissor = item.profissional.cbo.idOrgaoEmissor ? item.profissional.cbo.idOrgaoEmissor : '';
                profissionalEquipe.orgaoEmissor = item.profissional.cbo.orgaoEmissor ? item.profissional.cbo.orgaoEmissor : '';
                // tslint:disable-next-line:max-line-length
                profissionalEquipe.siglaUfConselhoClasse = item.profissional.cbo.siglaUfConselhoClasse ? item.profissional.cbo.siglaUfConselhoClasse : '';
                // tslint:disable-next-line:max-line-length
                profissionalEquipe.registroConselhoClasse = item.profissional.cbo.registroConselhoClasse ? item.profissional.cbo.registroConselhoClasse : '';
            }
            listaProfissionaisEquipe.push(profissionalEquipe);
        });
        return listaProfissionaisEquipe;
    }
}
